var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 4.66732H8.66536V6.00065H7.33203V4.66732ZM7.33203 7.33398H8.66536V11.334H7.33203V7.33398ZM7.9987 1.33398C4.3187 1.33398 1.33203 4.32065 1.33203 8.00065C1.33203 11.6807 4.3187 14.6673 7.9987 14.6673C11.6787 14.6673 14.6654 11.6807 14.6654 8.00065C14.6654 4.32065 11.6787 1.33398 7.9987 1.33398ZM7.9987 13.334C5.0587 13.334 2.66536 10.9407 2.66536 8.00065C2.66536 5.06065 5.0587 2.66732 7.9987 2.66732C10.9387 2.66732 13.332 5.06065 13.332 8.00065C13.332 10.9407 10.9387 13.334 7.9987 13.334Z",
    fill: "#89A6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.4cd0fc606dd612f94eec4f49168e0c7e.svg";
export { ForwardRef as ReactComponent };